import { render, staticRenderFns } from "./PasswordManage.vue?vue&type=template&id=52a95cd3&scoped=true&"
import script from "./PasswordManage.vue?vue&type=script&lang=js&"
export * from "./PasswordManage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordManage.vue?vue&type=style&index=0&id=52a95cd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a95cd3",
  null
  
)

export default component.exports